export default "__VITE_ASSET__D5S3Dy2v__"